import request from '@/utils/request'

//语音合成列表
export function getfaceLibraryList(data) {
    return request({
        url: '/general/faceLibrary/getList',
        method: 'post',
        data: data
    })
}
export function faceLibrarySearch(data) {
    return request({
        url: '/general/faceLibrary/search',
        method: 'post',
        data: data
    })
}
export function faceLibraryImg(data) {
    return request({
        url: '/general/faceLibraryImg/getList',
        method: 'post',
        data: data
    })
}
export function faceLibraryaddUser(data) {
    return request({
        url: '/general/faceLibrary/addUser',
        method: 'post',
        data: data
    })
}
export function faceLibraryaddFace(data) {
    return request({
        url: '/general/faceLibrary/addFace',
        method: 'post',
        data: data
    })
}

export function faceLibraryupd(data) {
    return request({
        url: '/general/faceLibrary/upd',
        method: 'post',
        data: data
    })
}

export function faceLibrarydelUser(data) {
    return request({
        url: '/general/faceLibrary/delUser',
        method: 'post',
        data: data
    })
}
export function  faceLibrarydelFace(data) {
    return request({
        url: '/general/faceLibrary/delFace',
        method: 'post',
        data: data
    })
}